import { ArrowNarrowLeftIcon, CheckCircleIcon, XCircleIcon } from "@heroicons/react/solid"
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import BaseView from "../components/BaseViewComponent"
import { FailedDialog, FormInput, LoadingDialog } from "../components/CommonComponents"
import Button from "../components/control/Button"
import API from "../conf/API"
import DataCenter, { loginCookie } from "../modules/DataCenter"
import { post, request } from "../utils/request"
import { checkEmail, checkPwd } from "../utils/Utils"
import cookie from 'react-cookies';
import { createModalDialog, ModalDialog, useModalDialog } from "../components/ModalDialog"
import { Events, JSEvent } from "../utils/JSEvent"
import { Localize, LocalStr } from "../modules/localize/Localize"

export default class LoginView extends BaseView {
    constructor(props) {
        super(props)
        this.initState({
            loading: false,
            autoLogin: false,
            saveInfo: false,
            regType: 0,
            loginCode: 0,
            loginResult: "",
        })
    }

    componentDidMount() {
        if (this.props.toRegView) {
            this.addView(RegisterView, "right", () => { },
                () => { }, {
                addView: this.addView,
                onRegSuccess: (uid, username) => {

                },
                referralCode: this.props.refCode
            });
        }
    }

    render() {
        const onLoginEvent = ({ name, payload }) => {
            if (name == "request") {
                this.setState({ loading: true })
            } else {
                this.setState({ loading: false })
                // if (name == "failed") {
                //     this.setState({ loginCode: -1, loginResult: payload })
                //     setTimeout(() => this.setState({ loginCode: 0 }), 1000)
                // }
            }
        }

        const onViewAction = (action) => {
            console.log(action)
        }

        return <CheckLogin>
            <div className="flex flex-col w-full h-full pt-10 px-5">
                <LocalStr msg={Localize.UI.Login.title} className="flex w-full text-2xl font-semibold pb-4" />
                <RegTypeSel select={this.state.regType} onChange={sel => {
                    this.setState({ regType: sel })
                }} />
                <div className="pt-5">
                    <LoginForm onLoginEvent={onLoginEvent} />
                    <div className="w-full flex">
                        <div className="flex-1 flex pt-5 text-sm" onClick={e => {
                            this.addView(RegisterView, "right", () => { },
                                onViewAction, {
                                addView: this.addView,
                                onRegSuccess: (uid, username) => {

                                }
                            });
                        }}>
                            {Localize.getMsg(Localize.UI.Login.registerNow)}
                        </div>
                        <div className="hidden flex-1 flex pt-5 text-sm justify-end" onClick={e => {

                        }}>
                            {Localize.getMsg(Localize.UI.Login.forget)}
                        </div>
                    </div>
                </div>
                <LoadingDialog show={this.state.loading} />
                <FailedDialog show={this.state.loginCode == -1} text={this.state.loginResult} />
                {this.state.views}
            </div>
        </CheckLogin>
    }
}

const CheckLogin = (props) => {
    const [loading, setLoading] = useState(true);
    const [checking, setChecking] = useState(true);
    const [systemReady, setSystemReady] = useState(DataCenter.systemReady);

    const nav = useNavigate();
    const cookieToken = cookie.load(loginCookie)
    console.log("cookie:", cookieToken);

    const onSystemReady = () => {
        setSystemReady(true);
    }

    //等待System.Ready事件
    useEffect(() => {
        JSEvent.on(Events.System.Ready, onSystemReady);
        return () => JSEvent.remove(Events.System.Ready, onSystemReady);
    }, [])

    useEffect(() => {
        if (systemReady == false) return;
        if (cookieToken != null) {
            //尝试检查当前token是否可用
            request(API.account_login_check({ accountId: cookieToken.id, loginKey: cookieToken.key, serviceId: DataCenter.serviceId() }))
                .then(ret => {
                    if (ret.code == 0) {
                        //DataCenter.setLoginInfo(cookieToken.id, cookieToken.key)
                        //DataCenter.init();
                        JSEvent.emit(Events.Login.LoginSuccessful, { id: cookieToken.id, key: cookieToken.key });
                        cookie.save(loginCookie, cookieToken
                            , { expires: new Date(new Date().getTime() + 5 * 24 * 3600 * 1000) })
                        nav("/")
                    } else {
                        cookie.remove(loginCookie)
                    }
                    setLoading(false);
                })
        } else if (DataCenter.firebaseToken != null) {
            //设置了firebaseToken，尝试已firebase渠道登陆
            console.log("Login With FirebaseToken:",DataCenter.firebaseToken)
            post(API.account_login(), { username: DataCenter.firebaseToken, password: "", serviceId: DataCenter.serviceId(), channel: DataCenter.channel })
                .then(ret => {
                    if (ret.code == 0) {
                        const { accountId } = ret.retObject;
                        //DataCenter.setLoginInfo(cookieToken.id, cookieToken.key)
                        //DataCenter.init();
                        JSEvent.emit(Events.Login.LoginSuccessful, { id: accountId, key: DataCenter.firebaseToken });
                        nav("/")
                    } else {
                        cookie.remove(loginCookie)
                    }
                    setLoading(false);
                })
        } else {
            setLoading(false);
        }
    }, [systemReady])
    return checking ? <LoadingDialog show={loading} onHidden={() => setChecking(false)} /> : props.children
}

const MyDialog = createModalDialog("dialog-login-msg")

const LoginForm = ({ onLoginEvent }) => {
    const nav = useNavigate();

    const modalDialog = useModalDialog("dialog-login-msg")

    const _onLoginEvent = ({ name, payload }) => {
        console.log(name, payload);
        if (name == "request") {
            request(API.account_login(), { method: "POST", body: payload })
                .then(ret => {
                    if (ret.code == -1) {
                        _onLoginEvent({ name: "failed", payload: ret.msg })
                    } else {
                        _onLoginEvent({ name: "success", payload: ret.retObject })
                    }
                })

        } else {
            if (name == "failed") {
                const args = {
                    title: <div className="flex">
                        <XCircleIcon className="w-6 h-6 text-red-400" /><LocalStr msg={Localize.UI.Login.failed} className="pl-2" />
                    </div>,
                    context: payload,
                    // buttons: [
                    //     { id: "ok", name: "确定", type: "primary", action: "close" },
                    //     { id: "cancel", name: "取消" }
                    // ]
                }
                modalDialog.show(args).then(b => console.log(b));
            } else if (name == "success") {
                //登陆成功了
                //DataCenter.setLoginInfo(payload.accountId, payload.msg)
                //DataCenter.init();
                JSEvent.emit(Events.Login.LoginSuccessful, { id: payload.accountId, key: payload.msg });
                cookie.save(loginCookie, { id: payload.accountId, key: payload.msg }
                    , { expires: new Date(new Date().getTime() + 5 * 24 * 3600 * 1000) })
                nav("/")
            }
        }
        if (onLoginEvent != null) {
            onLoginEvent({ name, payload })
        }
    }

    return <>
        <UserPwdForm regType={0} btnText="L:UI.Login.login" onLoginEvent={_onLoginEvent} />
        <MyDialog />
    </>
}


const RegTypeSel = ({ select, onChange }) => {
    const selStyle = "bg-gray-100 px-4 py-1 rounded-md mr-5 "
    const unselStyle = "px-4 py-1 rounded-md mr-5 "

    const onSelect = (sel) => {
        if (sel != select && onChange != null) {
            onChange(sel)
        }
    }

    return <div className="flex flex-row">
        <div className={select == 0 ? selStyle : unselStyle} onClick={e => { onSelect(0) }}>
            {Localize.getMsg(Localize.UI.Login.email)}
        </div>
        <div hidden className={select == 1 ? selStyle : unselStyle} onClick={e => { onSelect(1) }}>手机号码</div>
    </div>
}

const UserPwdForm = ({ regType, btnText, onLoginEvent }) => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    const inputEmail = useRef();
    const inputPwd = useRef();

    const emitLoginEvent = (name, payload) => {
        if (onLoginEvent != null) {
            onLoginEvent({ name: name, payload: payload })
        }
    }

    return <div className="flex flex-col w-full">
        {regType == 0 ? <>
            <LocalStr msg={Localize.UI.Login.email} className="flex" />
            <FormInput name="email"
                ref={inputEmail}
                validInput={(name, value) => {
                    if (checkEmail(value)) {
                        setUsername(value);
                        return "";
                    } else {
                        setUsername("");
                        return Localize.getMsg(Localize.UI.Login.emailError);
                    }
                }} />
        </> : <>
        </>
        }
        <LocalStr msg={Localize.UI.Login.password} className="flex pt-5" />
        <FormInput name="password" type="password"
            ref={inputPwd}
            validInput={(name, value) => {
                if (checkPwd(value)) {
                    setPassword(value);
                    return "";
                } else {
                    setPassword("");
                    return Localize.getMsg(Localize.UI.Login.passwordError);
                }
            }}
        />
        <div className="w-full flex pt-8">
            <Button widthStyle="w-full" type="primary" name={btnText} onClicked={() => {
                const validEmail = inputEmail.current.validateInput()
                const validPwd = inputPwd.current.validateInput();
                if (validEmail.valid && validPwd.valid) {
                    const data = { username: validEmail.value, password: validPwd.value, channel: DataCenter.channel, serviceId: DataCenter.serviceId() };
                    emitLoginEvent("request", data)
                }
            }} />
        </div>

    </div >
}


const RegisterView = (props) => {
    const [regType, setRegType] = useState(0)
    const [loading, setLoading] = useState(false);

    const modalDialog = useModalDialog("dialog-login-msg")

    const inputReferral = useRef(0);

    const { refCode } = useParams();

    useEffect(() => {
        if (refCode != null) {
            if (inputReferral.current != 0)
                inputReferral.current.setValue(refCode)
        }
    }, [])


    const onViewAction = (action) => {
        console.log(action)
    }

    const onLoginEvent = ({ name, payload }) => {
        if (name == "request") {
            setLoading(true);
            const { value } = inputReferral.current.validateInput();
            payload = { ...payload, referralCode: value };
            post(API.account_reg(), payload)
                .then(ret => {
                    if (ret.code == -1) {
                        onLoginEvent({ name: "failed", payload: ret.msg })
                    } else {
                        onLoginEvent({ name: "success", payload: { ...ret, regInfo: payload } })
                    }
                })
        } else if (name == "failed") {
            setLoading(false);
            const args = {
                title: <div className="flex">
                    <XCircleIcon className="w-6 h-6 text-red-400" /><LocalStr msg={Localize.UI.Login.failed} className="pl-2" />
                </div>,
                context: payload,
            }
            modalDialog.show(args).then(b => console.log(b));
        } else if (name == "success") {
            setLoading(false);
            props.addView(VerifyRegCode, "right", () => { }, onViewAction, {
                token: payload.msg,
                username: payload.regInfo.username,
                onRegResult: (success, uid) => {
                    //注册成功了，返回登陆界面
                    props.fireViewAction({ name: "close" });
                    if (success && props.onRegSuccess != null) {
                        props.onRegSuccess(uid, payload.regInfo.username)
                    }
                }
            });
        }
    }


    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-col items-start justify-center' onClick={() => props.fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" /></div>

        <LocalStr msg={Localize.UI.Register.title} className="flex w-full text-2xl font-semibold pb-4" />
        <RegTypeSel select={regType} onChange={sel => {
            setRegType(sel);
        }} />
        <div className="pt-5">
            <LocalStr msg={Localize.UI.Register.referral} className="flex" />
            <FormInput
                name="referral"
                ref={inputReferral}
            />
            <div className="pt-5"></div>
            <UserPwdForm regType={0} btnText="L:UI.Register.register" onLoginEvent={onLoginEvent} />
        </div>
        <LoadingDialog show={loading} />
        <MyDialog />
    </div>
}


const VerifyRegCode = (props) => {

    const [reSendCd, setReSendCd] = useState(60)
    const [errorCount, setErrorCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const inputRef = useRef();

    const modalDialog = useModalDialog("dialog-login-msg")

    useEffect(() => {
        if (reSendCd > 0) {
            setTimeout(() => {
                setReSendCd(reSendCd - 1)
            }, 1000)
        }
    }, [reSendCd])

    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-col items-start justify-center' onClick={() => props.fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" /></div>
        <LocalStr msg={Localize.UI.Login.emailValid} className="flex w-full text-2xl font-semibold pb-4" />
        <div className="flex w-full text-sm pb-4 text-gray-500">
            <LocalStr msg={Localize.UI.Login.inputCode} replacements={[props.username]} className="flex w-full text-sm pb-4 text-gray-500" />
        </div>

        <div className="flex flex-col w-full">
            <LocalStr msg={Localize.UI.Login.verificationCode} className="text-sm text-gray-500" />
            <FormInput name="verificationCode" type="number" showClearIcon={false} ref={inputRef}
                validInput={(name, value) => {
                    if (value.length != 6) {
                        return Localize.getMsg(Localize.UI.Login.verifyReason)
                    }
                }}
                suffix={<div className="  flex justify-center items-center text-red-900">
                    {reSendCd > 0 ? Localize.getMsg(Localize.UI.Login.sent) : <div onClick={e => {
                        setLoading(true);
                        request(API.account_resend_code({ username: props.username, token: props.token })).then(ret => {
                            setLoading(false);
                            if (!ret.error) {
                                setReSendCd(60)
                            }
                        })

                    }}>{Localize.getMsg(Localize.UI.Login.resend)}</div>}
                </div>}
            >

            </FormInput>
        </div>

        <div className="w-full flex pt-8">
            <Button type="primary" widthStyle="w-full" name="L:UI.Login.commit" onClicked={e => {
                const code = inputRef.current.validateInput();
                let ec = errorCount;
                if (code.valid) {
                    const body = { token: props.token, username: props.username, code: code.value }
                    setLoading(true);
                    setErrorCount(++ec);
                    post(API.account_verify_code(), body).then(ret => {
                        setLoading(false);
                        if (ret.error) {
                            const args = {
                                title: <div className="flex">
                                    <XCircleIcon className="w-6 h-6 text-red-400" /><LocalStr msg={Localize.UI.Login.varifyFailed} className="pl-2" />
                                </div>,
                                context: Localize.getMsg(Localize.UI.Login.verifyReason) //ec >= 3 ? "尝试次数过多" : ret.msg
                            }
                            modalDialog.show(args).then(b => {
                                if (ec >= 3) {
                                    props.fireViewAction({ name: "close" })
                                    if (props.onRegResult != null) {
                                        props.onRegResult(false, -1)
                                    }
                                }
                            })
                        } else {
                            const args = {
                                title: <div className="flex">
                                    <CheckCircleIcon className="w-6 h-6 text-green-400" /><LocalStr msg={Localize.UI.Login.successful} className="pl-2" />
                                </div>,
                                context: Localize.getMsg(Localize.UI.Login.successfulTip)
                            }
                            modalDialog.show(args).then(b => {
                                props.fireViewAction({ name: "close" })
                                if (props.onRegResult != null) {
                                    props.onRegResult(true, ret.msg)
                                }
                            })
                        }
                    })
                }
            }} />
        </div>
        <LoadingDialog show={loading} />
        <MyDialog />
    </div>
}

